/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_With_CodeInputs */

const vi_invoice_misa_template_with_code = /** @type {(inputs: Invoice_Misa_Template_With_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có mã cơ quan thuế`)
};

/**

* @param {Invoice_Misa_Template_With_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_with_code = /** @type {((inputs?: Invoice_Misa_Template_With_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_With_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_with_code(inputs)
});